export default {
    meta: {
        title: '升级专业版',
    },
};
